// Export utilities for analytics data

export function exportToCSV<T extends Record<string, any>>(
  data: T[],
  filename: string,
  headers?: Record<keyof T, string>
): void {
  if (data.length === 0) {
    console.warn("No data to export");
    return;
  }

  const keys = Object.keys(data[0]) as (keyof T)[];
  
  // Create header row
  const headerRow = keys.map(key => headers?.[key] || String(key)).join(",");
  
  // Create data rows
  const dataRows = data.map(row =>
    keys.map(key => {
      const value = row[key];
      // Handle values that might contain commas or quotes
      if (typeof value === "string" && (value.includes(",") || value.includes('"'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      if (value === null || value === undefined) {
        return "";
      }
      if (typeof value === "number") {
        return value.toFixed(2);
      }
      return String(value);
    }).join(",")
  ).join("\n");

  const csvContent = `${headerRow}\n${dataRows}`;
  downloadFile(csvContent, `${filename}.csv`, "text/csv");
}

export function exportToJSON<T>(data: T[], filename: string): void {
  const jsonContent = JSON.stringify(data, null, 2);
  downloadFile(jsonContent, `${filename}.json`, "application/json");
}

function downloadFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}

export function formatNumber(value: number, decimals: number = 2): string {
  return value.toFixed(decimals);
}

export function formatSOL(value: number): string {
  return `${value.toFixed(4)} SOL`;
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(dateString: string): string {
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function shortenWallet(wallet: string, chars: number = 4): string {
  if (wallet.length <= chars * 2 + 3) return wallet;
  return `${wallet.slice(0, chars)}...${wallet.slice(-chars)}`;
}
